const certificacao = [
    {
        path: '/certificacoes',
        meta: {
            roles: ['ROLE_FEATURE_CERTIFICACAO']
        },
        component: () => import('@/views/DefaultRouterView'),
        children: [
            {
                path: '',
                name: 'Certificacao',
                meta: {
                    roles: ['ROLE_FEATURE_CERTIFICACAO']
                },
                component: () =>
                    import('@/views/certificacao/GestaoCertificacao')
            },
            {
                path: 'certificacao/cadastrar',
                name: 'CadastrarCertificacao',
                meta: {
                    roles: ['ROLE_FEATURE_CERTIFICACAO']
                },
                component: () =>
                    import('@/views/certificacao/InserirCertificacao')
            },
            {
                path: 'certificacao/analise/:idCertificacao',
                name: 'VisualizarAnalise',
                meta: {
                    roles: ['ROLE_FEATURE_CERTIFICACAO']
                },
                component: () =>
                    import('@/views/certificacao/DetalhamentoAnalise')
            },
            {
                path: 'certificacao/visualizar',
                name: 'VisualizarCertificacao',
                meta: {
                    roles: ['ROLE_FEATURE_CERTIFICACAO']
                },
                component: () =>
                    import('@/views/certificacao/GestaoCertificacao')
            },
            {
                path: 'certificacao/visualizar-resultados-diagnosticos/:idCertificacaoTerritorio/:idCertificacaoTerritorioTipo',
                name: 'DetalhamentoResultadosDiagnosticos',
                meta: {
                    roles: ['ROLE_FEATURE_CERTIFICACAO']
                },
                component: () =>
                    import(
                        '@/views/certificacao/DetalhamentoResultadosDiagnosticos'
                    )
            }
        ]
    }
];

export default certificacao;
